var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn-edit",style:(("background-color: " + _vm.background + "; right: " + _vm.right + "px; top: " + _vm.top + "px")),attrs:{"type":"button"},on:{"click":function($event){_vm.$emit('edit-section')}}},[_c('img',{attrs:{"src":("/static/img/icon-" + _vm.icon + ".svg"),"alt":""}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cf9435fc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/commons/btn-edit.vue
// module id = 313
// module chunks = 10